// const LOCAL_URL = process.env.REACT_APP_LOCAL_URL;
// const LOCAL_URL = 'https://saas.sandbox.mykademy.com/';//'http://mykademy-v1-local.com/';
const LOCAL_URL = '';

export const API_URL = LOCAL_URL ? LOCAL_URL : window.location.origin + '/';
export const token_string = 'IDPATSN';
export const API_TOKEN_PREFIX = 'IDPAT';
export const CSRF_COOKIE_PREFIX = 'IDPCC';
export const CSRF_HEADER_PREFIX = 'IDPCH';
export const CSRF_TOKEN_PREFIX = 'IDPCT';
// if (process.env.NODE_ENV == 'development') {
//   // public/testdata/
//   console.log('LOCAL_URL', process.env.NODE_ENV);
//   console.log('API_URL', API_URL);
//   var _EXT = '.json';
//   var _post_meth = 'get';
// } else {
var _post_meth = 'post';
var _EXT = '';
// }
export const EXT = _EXT;
export const _post = _post_meth;
export let headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  // csrf_header: csrf_value,
};
export const reportModuleName = 'reports';
export const securityModuleNAme = 'security';
export const settingsModuleName = 'settings';
export const userManagementModuleName = 'usermanagement';
export const overviewModuleName = 'overview';
export const subscriptionModuleName = 'subscription';
export const accessManagementModuleName = 'accessmanagement';

export const organisationModuleName = 'organisation';
export const availableLanguages = [
  { label: 'EN', value: 'en' },
  { label: 'FR', value: 'fr' },
];

export const reminderModuleName             = 'reminders';
export const courseApprenticeshipModuleName = 'courseapprenticeship';
export const livelistModuleName             = 'livelist';
export const calendarModuleName             = 'learnercalendar';

// export const authToken    = 'mykademy mykademy:NzN07J7INMN6N-NGN0NjNb74N.7472NQ7HNF7k7R7R7u7271NWN_7fNcNQ7_N-N.75NLN7NbN3Ns7ONo7d7QNcNXN67v7HNGNJNv7kNoNm7uNRNcNgNJNQ717RNiNe7I7Q7U6261303736653535313835323734653139373132623565366431363737343533jMNMNgNONhN0NCNCNv7ZNj79ND7Y70jWN.jTNYNLN3N_NuNONjN-7wNHjCN3jCjA7JNi7aNHjAjXNQNlNJN_NlN9joNg7tNsNoj3NfjPNYNvjMNBjTNsjw7~7tjhNfNaN8N_NPjoN_NHNhNpNCjcjoNyjhN_jLN2N9jpNYjYNpNCNLNuNO70NTN87kNeNJ7xN.Ns7~NA7lNiNiNE7UNG7H7-NPNXNQ787rNhjLjoNtjWNaNtjzNyjhjtj.N1NtjmNaNlNqNsNZNM7r7ONGjsj3jpjVN.N~NiNJNKNPj67kjTN67C737tNQNRjNj_N_Nkj3NVjpjC7JNg7aNHjMjVNONANtN3jjjNjgNw7UjNjoj3NRjqN8Nwj3NfjPjpjtNSNCj7N4N2NTNtjNjTNMNdNDjDj.j8NM7175N.jsNuNwjpNtNp7f7CNwNvNfNdjejpNY7Hja';
// export const accessToken  = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6IjYxOCIsIm5hbWUiOiJhbGV4IiwiZW1haWxfaWQiOiJhbGV4LmFudG9ueUBteWthZGVteS5jb20iLCJtb2JpbGUiOiI3MzA2NTY5NDUzIiwidXNfbmFtZSI6ImFsZXgiLCJ1c19lbWFpbCI6ImFsZXguYW50b255QG15a2FkZW15LmNvbSIsInVzX3Bob25lIjoiNzMwNjU2OTQ1MyIsInVzX2dvb2dsZV9pZCI6IiIsInVzX2ZhY2Vib29rX2lkIjoiIiwiYWNjb3VudF9pZCI6IjIwMDAzIiwiaW5zdGl0dXRlX2lkIjoiMSJ9.YzW_I41zq8Mo5F_LUSPqNP5qaq9aN6Bbh0cGyJbMVM4';
//saas
export const authToken = 'mykademy student-dashboard:NbN_NwN3NxNO7uNL7r7.717dNb7.Nr7kNg7wNoNCNRNj79NeNvNXNh7uNR7HNzNsNx747wN7NpNPNpNwNt7v7R7dN_NV73NtNENWNq7t7r737Z7uNo7J7I7.No797J7FNDNE3835656236393035343230353735636531326563353834393930396262366136jiNijGjPNANH7.N87-7x7~7f7d7TNpN.jXN8jDjej3NyNSNFNzN87uN8N57BNuNXNlNLNe7aNo7fjhj8jqN.NzNRjgNZNPjWjDNmNo7LN-NAN0Nuj7NzN17xjoNS7xN0jLjPNHjijojWj.N-N6jPN.787u7QN5N8jTNkjcNLjojDjgj7NdN0jzN5j7N.NE7fNNNgNT747.7dNGNANzN6N.787Q75NQNm73NQNENE7I7p7GNANUNtjDNAN0N8NZNJNtNFjAjnNBjAj.jmjLjp7.NE7G7371NhNBN_jJNWjLNvN.jTNfjKNzN2N.7d7176joN_j7jgjXNRNgNUj8NZNXNRNnN6NpN5j8Nf7Cj3jXjojA7FNgNgNaNRjPN.NUNDjXNYNsNRjXjKN~jAjtNCjijQNONe7t78NJNujcNij6NwNb7RN7jWjwjcNwNFjsjX7lN6joNFjmjXjENwN3NaNPj8';
export const accessToken = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6IjE5NSIsIm5hbWUiOiJyb25pZSIsImVtYWlsX2lkIjoiYWxleC5hbnRvbnkrcm9uQG15a2FkZW15LmNvbSIsIm1vYmlsZSI6Ijg5MTIzMjQ1NDMiLCJ1c19uYW1lIjoicm9uaWUiLCJ1c19lbWFpbCI6ImFsZXguYW50b255K3JvbkBteWthZGVteS5jb20iLCJ1c19waG9uZSI6Ijg5MTIzMjQ1NDMiLCJ1c19nb29nbGVfaWQiOiIiLCJ1c19mYWNlYm9va19pZCI6IiIsImFjY291bnRfaWQiOiIyMTA1NCIsImluc3RpdHV0ZV9pZCI6IjIifQ.WV08f0n2MWMFu70zXa1dojS3AduesM_cWqsHfDbadGY';
let nodeApiUrl;
const checkDomainEnvironment = (url) => {
  try {
    const domain = new URL(url).hostname;
    return domain.includes("sandbox") || domain.includes("uat");
  } catch (error) {
    return false;
  }
};
if (window.location.hostname == 'local.mykademy.com') {
  nodeApiUrl = "http://localhost:8000/";
} else if (checkDomainEnvironment(window.location.hostname)) {
  nodeApiUrl = "https://enquiry-devapi.mykademy.com/";
} else {
  nodeApiUrl = "https://enquiry-api.mykademy.com/";
}

export const nodeUrl      = nodeApiUrl;
export const nodeUrlDev      = nodeApiUrl;
//export const nodeUrlDev   = 'https://enquiry-devapi.mykademy.com/';
//export const nodeUrl      = 'https://enquiry-devapi.mykademy.com/';//'https://enquiry-api.mykademy.com/';
export const idpUrl       = 'https://saas.sandbox.idp.mykademy.com/';
// export const idpUrl       = 'https://internal-idp-api.com/';
//saas

